import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyWhileloop = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="65%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – While Loop</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    Loops in Python Language is used to repeat a block of code
                    for several times until a specific result is obtained.
                    Suppose you have to print your name several times, instead
                    of printing multiple lines you can use loops. Python has two
                    types of loops.
                  </p>
                </div>
                <br />
                <br />

                <h1 className="py_h1">The While Loop in Python</h1>
                <p>
                  The while loop is a condition-controlled loop, it means it
                  will repeat until a specific condition is met. The statements
                  which you want to repeat must be indented, after a while
                  condition.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Syntax</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     Syntax:
                     while condition:
                         #statement
                         #statement
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">
                  Example 1: Python program to print 1 to 10.
                </h1>
                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=1
                     while n<=10:
                         print(n)
                         n=n+1
                       `}
                    </code>
                  </pre>
                  <p>
                    The above program will print 1 to 10 as output. An initial
                    value of a variable n is 1, the value of n is less than 10,
                    so the condition is true, after that it prints the value of
                    n, after that increase the value by 1. Every time it checks
                    the condition and repeats the statements until the condition
                    is not false.
                  </p>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">
                  Example 2: Python program to print your name 10 times.
                </h1>
                <hr style={{ color: "white" }} />

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=1
                     while n<=10:
                         print("Python Programming")
                         n=n+1
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">
                  Example 3: Python program to print 1 to 10 in the same line.
                </h1>
                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=1
                     while n<=10:
                         print(n,end='\t')
                         n=n+1
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1 mt-4">Python While with Else Statement</h1>
                <hr style={{ color: "white" }} />
                <p>
                  We can also use else statement with the loop in Python, when
                  the loop condition is false, then else block will execute. If
                  a break statement is executed in the loop block, then else
                  part will be skipped.
                </p>
                <h1 className="py_h1 mt-4">
                  Example 4: Python program to calculate the sum of 1 to 10.
                </h1>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=1
                     s=0
                     while n<=10:
                         s=s+n
                         n=n+1
                     else:
                         print("Sum :",s)
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>

              <hr style={{ color: "white" }} />
              <div className="row mt-5">
                <h1 className="py_h1 mt-4">
                  Use of If-Else Within While Block.
                </h1>
                <p>
                  We can also use if and else condition within while loop as a
                  statement.
                </p>
                <br />
                <br />
                <h1 className="py_h1 mt-4">
                  Example 5: Python program to accept numbers and calculate the
                  sum of even numbers only.
                </h1>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=1
                     s=0
                     while n<=10:
                         i=int(input("Enter a number"))
                         if i%2==0:
                             s=s+i
                         n=n+1
                     else:
                         print("Sum :",s)
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
